module.exports = __webpack_public_path__ + "img/ios_chrome.a7555203.gif";